import React, { useState, useEffect } from "react";
import { GitBranch } from "lucide-react"; // One-to-Many icon
import { Share2 } from "lucide-react"; // Many-to-Many icon
import {
  Plus,
  Minus,
  Hash,
  Facebook,
  Twitter,
  Instagram,
  GitBranch as BrandTiktok,
  Layers,
} from "lucide-react";

import { FaSync } from "react-icons/fa"; // Importing refresh icon

const PlatformFilter = ({ platforms, selectedPlatform, onSelect }) => {
  const getIcon = (platform) => {
    switch (platform.toLowerCase()) {
      case "facebook":
        return <Facebook className="w-5 h-5 text-black" />;
      case "instagram":
        return <Instagram className="w-5 h-5 text-black" />;
      case "twitter":
        return (
          <svg
            style={{ width: "20px", height: "20px" }}
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M16.44 3h3.56l-5.91 6.84L22 21h-6.2l-4.3-6.64L6 21H2.44L8.82 13.5 2 3h6.39l3.94 6.18L16.44 3zm-1.14 16h1.62L6.14 4H4.52l10.78 15z" />
          </svg>
        );
      case "tiktok":
        return (
          <svg
            style={{ width: "20px", height: "20px" }}
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div style={{ marginBottom: "24px" }}>
      {/* Label with Icon */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "12px",
        }}
      >
        <Layers style={{ width: "20px", height: "20px", color: "#374151" }} />{" "}
        {/* Direct Icon */}
        <span style={{ fontSize: "18px", fontWeight: "600", color: "#374151" }}>
          Select Platform
        </span>
      </div>

      {/* Platform Buttons */}
      <div style={{ display: "flex", gap: "16px" }}>
        {platforms.map((platform) => (
          <button
            key={platform}
            onClick={() => onSelect(platform.toLowerCase())}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "12px 32px",
              borderRadius: "12px",
              border: "1px solid",
              backgroundColor:
                selectedPlatform === platform.toLowerCase()
                  ? "#65ccb7"
                  : "transparent",
              color:
                selectedPlatform === platform.toLowerCase()
                  ? "white"
                  : "#4b5563",
              borderColor:
                selectedPlatform === platform.toLowerCase()
                  ? "#65ccb7"
                  : "#e5e7eb",
              fontSize: "16px",
              transition: "all 0.3s ease",
              cursor: "pointer",
              textTransform: "capitalize",
            }}
          >
            {getIcon(platform)}
            <span>{platform}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const RelationType = ({ selected, onChange }) => {
  const [showTooltip, setShowTooltip] = useState(false); // Move useState inside the component

  const [showTooltipMutual, setShowTooltipMutual] = useState(false); // Add this line

  return (
    <div
      style={{
        display: "flex",
        gap: "120px",

        padding: "16px",
        backgroundColor: "#f3f4f6",
        borderRadius: "12px",
      }}
    >
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          cursor: "pointer",
          position: "relative",
        }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <input
          type="radio"
          name="relationType"
          value="direct"
          checked={selected === "direct"}
          onChange={(e) => onChange(e.target.value)}
          style={{ position: "absolute", opacity: 0 }}
        />
        <div
          style={{
            width: "18px",
            height: "18px",
            border: "2px solid #e5e7eb",
            borderRadius: "50%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {selected === "direct" && (
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "#65ccb7",
                borderRadius: "50%",
                position: "absolute",
                top: "4px",
                left: "4px",
              }}
            />
          )}
        </div>
        <img
          src="/icons/O_T_M_Black.png"
          alt="One-to-Many"
          style={{ width: "25px", height: "25px" }}
        />{" "}
        {/* One-to-Many icon added */}
        <span style={{ fontSize: "14px", color: "#4b5563" }}>Direct</span>
        {/* Tooltip - Appears on Hover */}
        {showTooltip && (
          <div
            style={{
              position: "absolute",
              top: "30px",
              right: "0px", // Adjusted to keep tooltip inside screen bounds
              backgroundColor: "#333",
              color: "#fff",
              padding: "8px",
              borderRadius: "6px",
              fontSize: "12px",
              whiteSpace: "normal",
              maxWidth: "3500px", // Ensures better readability
              textAlign: "center",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              zIndex: 1000,
              width: "120%",
            }}
          >
            <strong>One to many relation</strong> <br />
            <strong>NOTE: User can select/add</strong>
            <strong style={{ color: "#65ccb7" }}> Only ONE </strong>hashtag.
          </div>
        )}
      </label>

      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          cursor: "pointer",
          position: "relative", // Needed for tooltip positioning
        }}
        onMouseEnter={() => setShowTooltipMutual(true)}
        onMouseLeave={() => setShowTooltipMutual(false)}
      >
        <input
          type="radio"
          name="relationType"
          value="mutual"
          checked={selected === "mutual"}
          onChange={(e) => onChange(e.target.value)}
          style={{ position: "absolute", opacity: 0 }}
        />
        <div
          style={{
            width: "18px",
            height: "18px",
            border: "2px solid #e5e7eb",
            borderRadius: "50%",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {selected === "mutual" && (
            <div
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: "#65ccb7",
                borderRadius: "50%",
                position: "absolute",
                top: "4px",
                left: "4px",
              }}
            />
          )}
        </div>

        <img
          src="/icons/M_T_M_Black.png"
          alt="Many-to-Many"
          style={{ width: "25px", height: "25px" }}
        />
        {/* Many-to-Many icon added */}
        <span style={{ fontSize: "14px", color: "#4b5563" }}>Mutual</span>

        {/* Tooltip - Appears on Hover */}
        {showTooltipMutual && (
          <div
            style={{
              position: "absolute",
              top: "30px",
              right: "0px", // Adjust to prevent cut-off
              backgroundColor: "#333",
              color: "#fff",
              padding: "8px",
              borderRadius: "6px",
              fontSize: "12px",
              whiteSpace: "normal",
              maxWidth: "3500px", // Better readability
              textAlign: "center",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              zIndex: 1000,
              width: "120%",
            }}
          >
            <strong>Many to Many Relation</strong> <br />
            <strong>NOTE:</strong> User can select/add
            <strong style={{ color: "#65ccb7" }}> MULTIPLE </strong> hashtags.
          </div>
        )}
      </label>
    </div>
  );
};

const HashtagList = ({ hashtags, onSelect, isSelected, searchQuery }) => {
  const [hoveredHashtag, setHoveredHashtag] = useState(null); // Hover state

  const filteredHashtags = searchQuery
    ? hashtags.filter((hashtag) =>
        hashtag.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : hashtags;

  if (filteredHashtags.length === 0) {
    return (
      <div
        style={{
          border: "1px solid #e5e7eb",
          borderRadius: "12px",
          padding: "16px",
          textAlign: "center",
        }}
      >
        <p style={{ color: "#6b7280" }}>Hashtag not found</p>
      </div>
    );
  }

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        padding: "16px",
        maxHeight: "300px",
        overflowY: "auto",
      }}
    >
      {filteredHashtags.map((hashtag, index) => (
        <div
          key={hashtag}
          onMouseEnter={() => setHoveredHashtag(hashtag)}
          onMouseLeave={() => setHoveredHashtag(null)}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "12px",
            borderBottom: "1px solid #e5e7eb",
            cursor: "pointer",
            backgroundColor:
              hoveredHashtag === hashtag ? "#f3f4f6" : "transparent", // Hover effect
            transition: "background-color 0.3s ease",
          }}
        >
          {/* Hashtag with numbering */}
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                color: "#3b82f6",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              #{hashtag}
            </span>
            <span
              style={{
                fontSize: "14px",
                color: "#FF0000",
              }}
            >
              Target {index + 1}
            </span>
          </div>

          {/* Add/Remove Button */}
          <button
            onClick={() => onSelect(hashtag)}
            style={{
              padding: "8px",
              borderRadius: "50%",
              backgroundColor: isSelected(hashtag) ? "#f87171" : "#65ccb7",
              color: "white",
              transition: "background-color 0.3s ease",
              cursor: "pointer",
              border: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {isSelected(hashtag) ? (
              <Minus style={{ width: "20px", height: "20px" }} />
            ) : (
              <Plus style={{ width: "20px", height: "20px" }} />
            )}
          </button>
        </div>
      ))}
    </div>
  );
};
const HashtagSection = ({
  hashtags,
  selectedHashtags,
  onHashtagSelect,
  onHashtagRemove,
  selectedPlatform,
  onPlatformChange,
  platforms,
  relationType,
  onRelationTypeChange,
}) => {
  const [newHashtag, setNewHashtag] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false); // Add a state for submitting

  useEffect(() => {
    if (selectedHashtags.length > 0 && !isSubmitting) {
      // Ensure we aren't submitting twice
      const data = {
        platform: selectedPlatform,
        hashtags: selectedHashtags,
      };
      console.log("Submitting data:", data);
      setIsSubmitting(true); // Call the callback to submit the data
    }
  }, [selectedHashtags, selectedPlatform, isSubmitting]); // Track only necessary dependencies

  // Handle selecting a hashtag
  const handleHashtagSelect = (hashtag) => {
    if (relationType === "direct") {
      // Allow only one hashtag for direct relation
      if (selectedHashtags.length === 0) {
        onHashtagSelect([hashtag]);
      } else {
        alert("You can only select one hashtag for Direct relation.");
      }
    } else if (relationType === "mutual") {
      // Allow multiple hashtags for mutual relation
      if (!selectedHashtags.includes(hashtag)) {
        // Add the new hashtag to the list if it's not already selected
        onHashtagSelect([...selectedHashtags, hashtag]);
      } else {
        // If the hashtag is already selected, remove it from the list (toggle behavior)
        onHashtagSelect(selectedHashtags.filter((item) => item !== hashtag));
      }
    }
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    // Handle the hashtag logic here (if any new hashtag is provided)
    if (newHashtag.trim()) {
      const cleanHashtag = newHashtag.trim().replace(/^#/, "");
      handleHashtagSelect(cleanHashtag);
      setNewHashtag("");
    }
  };

  return (
    <div>
      <h3
        style={{
          fontSize: "20px",
          fontWeight: "700",
          marginBottom: "20px",
          display: "flex",
          alignItems: "center",
          gap: "10px", // Spacing between icon and text
        }}
      >
        <Hash style={{ width: "24px", height: "24px" }} />{" "}
        {/* Hashtag icon added */}
        HASHTAGS
        <div style={{ marginLeft: "auto" }}>
          <button
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "12px 32px",
              borderRadius: "12px",
              border: "1px solid rgb(101, 204, 183)",
              backgroundColor: "rgb(101, 204, 183)",
              color: "white",
              fontSize: "16px",
              transition: "0.3s",
              cursor: "pointer",
              textTransform: "capitalize",
            }}
          >
            <FaSync /> {/* Refresh icon */}
          </button>
        </div>
      </h3>

      <h2
        style={{
          fontSize: "18px",
          fontWeight: "600",
          marginBottom: "24px",
          color: "#707070",
        }}
      >
        Mapping of Profiles with respect to Hashtags
      </h2>

      <PlatformFilter
        platforms={platforms}
        selectedPlatform={selectedPlatform}
        onSelect={onPlatformChange}
      />

      <RelationType selected={relationType} onChange={onRelationTypeChange} />

      {error && (
        <div
          style={{
            marginBottom: "24px",
            padding: "16px",
            backgroundColor: "#fef2f2",
            color: "#dc2626",
            borderRadius: "12px",
          }}
        >
          {error}
        </div>
      )}

      <div
        style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px" }}
      >
        <div>
          <h4
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: "#1f2937",
              marginBottom: "12px",
            }}
          >
            Trending Hashtags
          </h4>
          <div style={{ marginBottom: "16px" }}>
            <div style={{ position: "relative" }}>
              <Hash
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  width: "16px",
                  height: "16px",
                  color: "#d1d5db",
                }}
              />
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search hashtags..."
                style={{
                  width: "100%",
                  paddingLeft: "40px",
                  paddingRight: "16px",
                  paddingTop: "8px",
                  paddingBottom: "8px",
                  borderRadius: "12px",
                  border: "1px solid #e5e7eb",
                  outline: "none",
                  boxSizing: "border-box",
                  fontSize: "16px",
                }}
              />
            </div>
          </div>
          <HashtagList
            hashtags={hashtags}
            onSelect={handleHashtagSelect}
            isSelected={(hashtag) => selectedHashtags.includes(hashtag)}
            searchQuery={searchQuery}
          />
        </div>
        <div>
          <div style={{ marginBottom: "16px" }}>
            <h4
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#1f2937",
                marginBottom: "12px",
              }}
            >
              Selected Hashtags
            </h4>
            <form onSubmit={handleSubmit} style={{ marginBottom: "16px" }}>
              <div style={{ display: "flex", gap: "12px" }}>
                <div style={{ position: "relative", flex: 1 }}>
                  <Hash
                    style={{
                      position: "absolute",
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "16px",
                      height: "16px",
                      color: "#d1d5db",
                    }}
                  />
                  <input
                    type="text"
                    value={newHashtag}
                    onChange={(e) => setNewHashtag(e.target.value)}
                    placeholder="Add custom hashtag..."
                    style={{
                      width: "100%",
                      paddingLeft: "40px",
                      paddingRight: "16px",
                      paddingTop: "8px",
                      paddingBottom: "8px",
                      borderRadius: "12px",
                      border: "1px solid #e5e7eb",
                      outline: "none",
                      boxSizing: "border-box",
                      fontSize: "16px",
                    }}
                  />
                </div>
                <button
                  type="submit"
                  disabled={!newHashtag.trim()}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "12px",
                    fontSize: "16px",
                    fontWeight: "500",
                    backgroundColor: newHashtag.trim() ? "#65ccb7" : "#f3f4f6",
                    color: newHashtag.trim() ? "white" : "#9ca3af",
                    cursor: newHashtag.trim() ? "pointer" : "not-allowed",
                  }}
                >
                  Add Hashtags
                </button>
              </div>
            </form>
          </div>
          <HashtagList
            hashtags={selectedHashtags}
            onSelect={onHashtagRemove}
            isSelected={() => true}
          />
        </div>
      </div>
    </div>
  );
};

export default HashtagSection;
